import { EmpeDriveApiClient } from '@/api-clients/empe-drive-client';
import { Album } from '@/models/album';

export const getAlbum = async (albumId: Album['id']) => {
    return await EmpeDriveApiClient.get<Album>(`/albums/${albumId}`);
};
